export function IconTrash() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M9 2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v1H.75a.75.75 0 0 0 0 1.5h.565l.831 5.717a1.75 1.75 0 0 0 1.737 1.533h4.234a1.75 1.75 0 0 0 1.737-1.533l.831-5.717h.565a.75.75 0 0 0 0-1.5H9V2zM7.5 3V2a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v1h3zM2.83 4.5h6.34l-.805 5.531a.25.25 0 0 1-.248.219H3.883a.25.25 0 0 1-.248-.219L2.83 4.5zM5 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5.5a.5.5 0 0 0-1 0v2.5a.5.5 0 0 0 1 0V6z" fill="#6b7276"/>
        </svg>
    );
}
